/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
import PRM from "@/core/PermissionConstants";

export default {
  path: "/app/estudios/historico_estudios",
  name: "HISTORY_STUDIES",
  component: () => import("@/app/views/SimpleTableView.vue"),
  meta: {
    service: () => import("@/app/services/HistoryStudiesService"),
    table: () => import("@/app/components/studies/HistoryStudiesTable.vue"),
    header: {
      icono: "mdi-book",
      texto: "Histórico Estudios",
    },
    //  prm: PRM.MODULE_DENTAL_ATTEND,
    requireAuth: true,
    filterDate: true,
    filterModality: true,
    downloadButtonText: "Descargar estudios"
  },
};
